import * as React from 'react';
import countries, { Option } from '../../utils/countries';

type UserInfoForm = {
  userName: string;
  setUserName: Function;
  userEmail: string;
  setUserEmail: Function;
  setUserPassword: Function;
  userCountry?: string;
  setUserCountry?: Function;
};

export default function UserInfoForm(props: UserInfoForm) {
  return (
    <React.Fragment>
      <div className="measure-wide">
        <label htmlFor="name" className="f6 b db mb2 ttu black-50 fw6">
          Your Name
        </label>
        <input
          id="name"
          className="input-reset ba b--black-20 pa2 mb2 db w-100"
          type="text"
          required
          name="name"
          onChange={(e) => props.setUserName(e.target.value)}
          defaultValue={props.userName}
        />
      </div>
      {props.setUserCountry ? (
        <div className="measure-wide">
          <label htmlFor="country" className="f6 b db mb2 ttu black-50 fw6">
            Country of residence
          </label>
          <select
            id="country"
            className="input-reset ba b--black-20 pa2 mb2 db w-100"
            required
            name="country"
            onChange={(e) => props.setUserCountry(e.target.value)}
          >
            <option value="">Please Select</option>
            {countries().map((country: Option) => (
              <option value={country.value}>{country.label}</option>
            ))}
          </select>
        </div>
      ) : null}
      <div className="measure-wide">
        <label htmlFor="email" className="f6 b db mb2 ttu black-50 fw6">
          Email
        </label>
        <input
          id="email"
          className="input-reset ba b--black-20 pa2 mb2 db w-100"
          type="email"
          required
          name="email"
          onChange={(e) => props.setUserEmail(e.target.value)}
          defaultValue={props.userEmail}
          autoComplete="email"
        />
      </div>
      <div className="measure-wide">
        <label htmlFor="password" className="f6 b db mb2 ttu black-50 fw6">
          Password
        </label>
        <input
          id="password"
          className="input-reset ba b--black-20 pa2 mb2 db w-100"
          type="password"
          required
          name="password"
          onChange={(e) => props.setUserPassword(e.target.value)}
          autoComplete="new-password"
        />
      </div>
      <small className="f6 black-60 db mv2">
        By registering you are agreeing to
        <a href="/terms.html" className="link gold b underline-hover">
          Terms &amp; Conditions
        </a>
      </small>
    </React.Fragment>
  );
}
